import { State } from 'modules';
import { ListModel } from 'types/models';

export const getListById = (
  state: State,
  idList: string,
): ListModel | undefined =>
  state.models.lists.find((list: ListModel) => list.id === idList);



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/lists.ts